import { useOpenUrl } from "@coinbase/onchainkit/minikit";
import { useMutation, useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { ReadonlyURLSearchParams } from "next/navigation";
import { useDispatch } from "react-redux";
import { authActions, userActions } from "../redux/actions";
import { useAppDispatch } from "../redux/hooks";
import { useAxiosPrivate } from "./useAxiosPrivate";

export const useConnectTwitterAppMutation = () => {
  const axios = useAxiosPrivate();

  const dispatch = useAppDispatch();
  const openUrl = useOpenUrl();

  async function connectTwitter(domain: string) {
    const { data } = await axios.post(`auth/twitter/connect`, { domain });
    return data;
  }

  function onSuccess(resp: { sid: string; url: string }) {
    localStorage.setItem("sid", resp.sid);
    dispatch(userActions.setUser(resp));
    console.log("resp here", resp);

    openUrl(resp.url);
  }

  // on Error
  function onError(error: AxiosError) {
    console.log({ error });
  }

  return useMutation({
    mutationKey: ["CONNECT_TWITTER"],
    mutationFn: connectTwitter,
    onSuccess,
    onError,
    retry: 0,
  });
};

export const useVerifyTwitterIntegrationQuery = (
  query: ReadonlyURLSearchParams,
  dependsOn = true,
) => {
  const axios = useAxiosPrivate();
  const dispatch = useDispatch();
  const params = query ? Object.fromEntries(query.entries()) : {};

  const payload = {
    domain: "frame-swarm.vercel.app",
    code: params.code,
    state: params.state,
    error: params.error,
  };

  async function verifyTwitter() {
    const { data } = await axios.post<{
      accessToken: string;
      refreshToken: string;
    }>(`auth/twitter/verify`, payload);

    const { accessToken, refreshToken } = data;

    if (accessToken) {
      localStorage.setItem("accessToken", accessToken);
      localStorage.setItem("refreshToken", refreshToken);
      dispatch(authActions.setAccessToken(accessToken));
      // localStorage.setItem("refreshToken", refreshToken);
    }

    return data;
  }

  // // on Success
  // const onSuccess = ({ accessToken }: { accessToken: string }) => {
  //   handleRedirect(accessToken);
  // };

  // // on Error
  // function onError(error: AxiosError) {
  //   router.push("/");
  // }

  return useQuery({
    queryKey: ["VERIFY_TWITTER", params],
    queryFn: verifyTwitter,
    // onSuccess,
    // onError,
    retry: 0,
    enabled: dependsOn,
  });
};

export const useLogoutMutation = () => {
  const axios = useAxiosPrivate();

  async function logout(refreshToken: string) {
    await axios.post(
      `/auth/logout`,
      {},
      {
        headers: {
          Authorization: `Bearer ${refreshToken}`,
        },
      },
    );
  }

  function onSuccess() {
    const encryptedCodeMaps = localStorage.getItem("encryptedCodesMap");
    localStorage.clear();
    if (encryptedCodeMaps) {
      localStorage.setItem("encryptedCodesMap", encryptedCodeMaps);
    }
    sessionStorage.clear();
  }

  return useMutation({
    mutationKey: ["LOGOUT"],
    mutationFn: logout,
    onSuccess,
  });
};

export const useGetMeQuery = (dependsOn = true) => {
  const dispatch = useAppDispatch();
  const axios = useAxiosPrivate();
  // const path = usePathname();

  // const isHomePage = path === "/";
  // const router = useRouter();

  async function getMe() {
    const { data } = await axios.get(`/auth/me`);

    dispatch(authActions.setMe(data));

    return data;
  }

  // function onSuccess(resp?: TGetMeResDto) {
  //   dispatch(authActions.setMe(resp));
  //   if (isHomePage) {
  //     router.push("/dashboard");
  //   }
  // }

  // on Error
  // function onError(error: AxiosError) {
  //   console.log({ error });
  //   //
  // }

  return useQuery({
    queryKey: ["GET_ME"],
    queryFn: getMe,
    // onSuccess,
    // onError,
    enabled: dependsOn,
    retry: 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};

